import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-bootstrap/esm/Alert.js");
;
import(/* webpackMode: "eager", webpackExports: ["Menu"] */ "/app/src/hooks/useGetContent/ContentItemComponents/Menu.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["UseSessionClient"] */ "/app/src/hooks/useSessionClient.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/partials/support/Kenniscentrum/ContentItem.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["QuizItem"] */ "/app/src/partials/support/Kenniscentrum/QuizItem.jsx");
